<div class="linked-data-dialog">

  <div class="close" (click)="closeDialog()"></div>

  <div class="right-sub-section-holder">
    <div class="icon-link-data"></div>
    <p>
      Primerjava
    </p>
  </div>

  <h1>{{ dialogData.object.Title }}</h1>
  <!--<h2>{{findTheRecord}}</h2>-->

  <div class="tree-wrapper">

    <div class="added-items">
      <p class="compare-label">Dodani tekmovalni tipi:</p>
      @if (dataSource?.data?.length == 0) {
        <p>/</p>
      }
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
          <li class="mat-tree-node">
            <!-- use a disabled button to provide padding for tree leaf -->
            <button mat-icon-button disabled></button>
            {{node.name}}
          </li>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
          <li>
            <div class="mat-tree-node">
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              {{node.name}}
            </div>
            <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
              <ng-container matTreeNodeOutlet></ng-container>
            </ul>
          </li>
        </mat-nested-tree-node>
      </mat-tree>
    </div>

    <div class="tree-separator st"></div>

    <div class="removed-items">
      <p  class="compare-label">Odstranjeni tekmovalni tipi:</p>
      @if (dataSourceRemoved?.data?.length == 0) {
        <p>/</p>
      }
      <mat-tree [dataSource]="dataSourceRemoved" [treeControl]="treeControlRemoved" class="example-tree">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
          <li class="mat-tree-node">
            <!-- use a disabled button to provide padding for tree leaf -->
            <button mat-icon-button disabled></button>
            {{node.name}}
          </li>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
          <li>
            <div class="mat-tree-node">
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControlRemoved.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              {{node.name}}
            </div>
            <ul [class.example-tree-invisible]="!treeControlRemoved.isExpanded(node)">
              <ng-container matTreeNodeOutlet></ng-container>
            </ul>
          </li>
        </mat-nested-tree-node>
      </mat-tree>
    </div>

    <div class="tree-separator nd"></div>

    <div class="removed-items">
      <p class="compare-label">Spremenjeni tekmovalni tipi:</p>
      @if (dataSourceMod?.data?.length == 0) {
        <p>/</p>
      }
      <mat-tree [dataSource]="dataSourceMod" [treeControl]="treeControlMod" class="example-tree">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
          <li class="mat-tree-node">
            <!-- use a disabled button to provide padding for tree leaf -->
            <button mat-icon-button disabled></button>
            {{node.name}}
          </li>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
          <li>
            <div class="mat-tree-node">
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControlMod.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              {{node.name}}
            </div>
            <ul [class.example-tree-invisible]="!treeControlMod.isExpanded(node)">
              <ng-container matTreeNodeOutlet></ng-container>
            </ul>
          </li>
        </mat-nested-tree-node>
      </mat-tree>
    </div>

  </div>

  <div class="simple-changes">
    <p class="compare-label">Spremenjeni osnovni podatki:</p>
    @for (prop of simpleProps; track prop) {
      <div class="prop-val">
        <p class="prop-val-name">{{translationService.translate(prop.Name)}}</p>
        <p class="simple-change-before">prejšnja vrednost: {{prop.OldValue | date: 'dd.MM.yyyy':'CET'}} => </p>
        <p class="simple-change-after">nova vrednost: {{prop.NewValue | date: 'dd.MM.yyyy':'CET'}}</p>
      </div>
    }
  </div>

  <div class="btns compare-btns">
    <button class="compare-confirm-btn" (click)="confirm()">Potrdi</button>
    <button class="compare-cancel-btn" (click)="closeDialog()">Prekliči</button>
  </div>

</div>
